import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'FINANCIAL_RECONCILIATION',
    icon: 'menu-financial-reconciliation',
    label: '财务报表',
    path: '/financial-reconciliation',
  },
] satisfies Menu[];
